import Collapse from './collapse';
import mapProp from '../scripts/utils/map-props';

export default mapProp(
  [
    'active',
  ],
  {
    model: {
      prop: 'active',
      event: 'change',
    },
  }
)(Collapse);
